import React from "react";
import SocialLinks from "./SocialLinks";
import { Link } from "react-scroll";
import { BsFillPersonLinesFill, BsTelephoneOutboundFill } from "react-icons/bs";


function About() {
  const handleResumeDownload = () => {
    const resumeURL =
      "https://drive.google.com/file/d/135kRCX_6ceX2hohmOELduZRr9liELGUp/view?usp=sharing";
    window.open(resumeURL, "_blank");
  };
  return (
    <div
      name="about"
      id="about"
      className="w-full min-h-screen bg-gradient-to-b from-gray-800 to-black text-white about section"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p
            className="text-4xl font-bold inline border-b-4 border-gray-500"
            id="user-detail-name"
          >
            About
          </p>
        </div>
        <p className="text-xl mt-20">
          Greetings! I'm Gaurav Shukla, a versatile full stack web developer
          based in India. With expertise in front-end technologies such as HTML,
          CSS (including libraries like Chakra UI, Material UI, and Tailwind
          CSS), and JavaScript (including frameworks like React).
        </p>

        <br />

        <p className="text-xl" id="user-detail-intro">
          I also have a strong command over backend technologies like Node.js,
          Express.js, and MongoDB. Continuously expanding my skill set, I am
          dedicated to delivering exceptional digital experiences. Let's
          collaborate and bring your ideas to life with a robust and dynamic web
          application!
        </p>
        <div className="flex">
        <a
            href="/Gaurav-Shukla-Resume.pdf"
            className="group text-white w-fit px-6 py-3 my-4 flex items-center mr-40 rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            download
            onClick={handleResumeDownload}
            id="resume-link-2"
          >
            Resume 
          </a>
          </div>
      </div>
      <SocialLinks />
    </div>
  );
}

export default About;
